import React from 'react';
import { FiCheckCircle, FiCoffee, FiEdit3, FiMessageSquare, FiMonitor, FiUser, FiVideo } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { PiStudent } from 'react-icons/pi';
import IconPerformance from '@/components/custom/icons/IconPerformance';
import { BsFileEarmarkCheck } from 'react-icons/bs';
import { DashboardSection, DashboardSectionTitle } from '@/components/custom/dashboard';
import { Button, ButtonIcon } from '@/components/ui/button';
import { QuickActions } from '@/components/custom/quick-actions';

export function DashboardQuickActions({ mostVisited }) {
  const getMostVisitedData = path => {
    switch (path) {
      case '/curso/admin':
        return {
          id: 1,
          title: 'Cursos',
          icon: <FiMonitor />
        };
      case '/turmas':
        return {
          id: 2,
          title: 'Turmas',
          icon: <PiStudent />
        };
      case '/feed':
        return {
          id: 3,
          title: 'Fórum',
          icon: <FiCoffee />
        };
      case '/avaliacoes/:selectedTab':
        return {
          id: 4,
          title: 'Avaliações',
          icon: <FiCheckCircle />
        };
      case '/aulas-ao-vivo':
        return {
          id: 5,
          title: 'Aulas ao vivo',
          icon: <FiVideo />
        };
      case '/auditorio':
        return {
          id: 6,
          title: 'Monitoria',
          icon: <FiMessageSquare />
        };
      case '/participantes':
        return {
          id: 7,
          title: 'Usuários',
          icon: <FiUser />
        };
      case '/metricas/:selectedTab':
        return {
          id: 8,
          title: 'Relatórios',
          icon: <IconPerformance />
        };
      case '/redacao':
        return {
          id: 9,
          title: 'Redação',
          icon: <FiEdit3 />
        };
      case '/atividade-complementar':
        return {
          id: 10,
          title: 'Atividade Complementar',
          icon: <BsFileEarmarkCheck />
        };
    }
  };

  const formatedPath = path => {
    if (path.includes('metricas/:selectedTab')) {
      return 'metricas/institutional';
    } else if (path.includes('/:selectedTab')) {
      return path.replace('/:selectedTab', '');
    } else {
      return path;
    }
  };

  return (
    <DashboardSection>
      <DashboardSectionTitle>Mais acessados por você</DashboardSectionTitle>

      <QuickActions>
        {mostVisited?.slice(0, 4).map(item => (
          <Button
            key={getMostVisitedData(item.path).id}
            className="w-32 grow"
            asChild
          >
            <Link to={formatedPath(item.path)}>
              <ButtonIcon size="md">{getMostVisitedData(item.path).icon}</ButtonIcon> {getMostVisitedData(item.path).title}
            </Link>
          </Button>
        ))}
      </QuickActions>
    </DashboardSection>
  );
}
